export type BoldSignClientSideAction =
  | BoldSignPreparationClientSideAction
  | BoldSignSigningClientSideAction;

/**
 * https://developers.boldsign.com/embedded-request/embed-in-an-iFrame/?region=us#client-side-events
 */
export type BoldSignPreparationClientSideAction =
  | "onDraftSuccess"
  | "onDraftFailed"
  | "onCreateSuccess"
  | "onCreateFailed"
  | "onLoadComplete"
  | "onPageNavigation";

/** https://developers.boldsign.com/embedded-signing/embed-in-an-iFrame/?region=us#client-side-events */
export type BoldSignSigningClientSideAction =
  | "onDocumentSigned"
  | "onDocumentSigningFailed"
  | "onDocumentReassigned"
  | "onDocumentReassigningFailed"
  | "onDocumentDeclined"
  | "onDocumentDecliningFailed";

export type BoldSignData =
  | BoldSignPreparationClientSideAction
  | {
      action?: BoldSignClientSideAction; // BoldSign sends { action: "<event>" }
    };

export const BOLDSIGN_ORIGIN = "https://app.boldsign.com";
